/**
 * inboxApi — web wrapper, mirrors RN. Binds @wg/api/inbox to the web's authenticated
 * httpClient. Same surface as RN: getNotifications, markAsRead, markAllAsRead, etc.
 */
import { createInboxApi } from '@wg/api/inbox';
import type { InboxApi } from '@wg/api/inbox';
import { httpClient } from '../http';
import logger from '../utils/logger';

const inboxApi: InboxApi = createInboxApi(httpClient, logger);

export default inboxApi;
export type { InboxApi };
export type {
  Notification,
  NotificationCategory,
  NotificationStatus,
  NotificationAction,
  NotificationPreferences,
} from '@wg/types';
